import { render, staticRenderFns } from "./EventType.vue?vue&type=template&id=248466d2"
import script from "./EventType.vue?vue&type=script&lang=js"
export * from "./EventType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports